<h1>Something is wrong with your account</h1>
<p>
  You do have an account for Camunda Cloud, but you aren't part of any
  organization yet. Please contact
  <cm-link href="mailto:cloudbeta@camunda.com">cloudbeta@camunda.com</cm-link>.
</p>
